// Tokens visuais do cadastro de desconto v2 (mesmos do kit dos dashboards: resources/dashboards/shared).
// Os tokens genéricos moraram aqui até a campanha de recuperação precisar dos mesmos: agora
// vêm de components/wizardKit e este arquivo os repassa, para os 15 importadores daqui não mudarem.
import { C, CALLOUT, focusRing, kitCardSx } from '../../../../components/wizardKit/tokens'
import { DiscountKind } from '../types'

export { C, CALLOUT, focusRing, kitCardSx }

/**
 * Cores por tipo (as do cadastro antigo e da lista). O texto do selo é um tom mais escuro no Especial e na Recuperação:
 * com o cartão marcado, o selo translúcido fica sobre o fundo translúcido do cartão e o contraste caía abaixo de 4,5:1.
 */
export const TYPE_STYLE: Record<DiscountKind, { color: string; ink: string; tint: string }> = {
  [DiscountKind.default]: { color: '#607d8b', ink: '#455a64', tint: 'rgba(96,125,139,.12)' },
  [DiscountKind.special]: { color: '#1976d2', ink: '#135fb5', tint: 'rgba(25,118,210,.10)' },
  [DiscountKind.reward]: { color: '#7b1fa2', ink: '#6a1b9a', tint: 'rgba(123,31,162,.09)' },
  [DiscountKind.recovery]: { color: '#e65100', ink: '#b43209', tint: 'rgba(230,81,0,.09)' },
}

// ─── Estilos que ficam fora do JSX ──────────────────────────────────────────────
// O plugin de i18n (scripts/i18n/babel-plugin-i18n-wrap.mjs) embrulha em __t() todo literal de texto que acha dentro de um
// `&&`/ternário de JSX, inclusive valores de `sx` ('sticky', '12px 14px'), e eles viram "texto a traduzir". Estilo que vive
// debaixo de condicional mora aqui, em constante de módulo, e o JSX só escolhe entre constantes.

export const fillSx = { flex: '1 1 0', minWidth: 0, width: '100%' } as const
export const buttonsRowSx = { display: 'flex', flexWrap: 'wrap', gap: 1 } as const
export const stackStartSx = { display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'flex-start' } as const
export const retryButtonSx = { height: 40, px: 1.75, fontSize: 14, fontWeight: 700, color: CALLOUT.errorText, borderColor: CALLOUT.errorText } as const

/** O botão "Como funciona" é um componente compartilhado: aqui ganha o violeta da tela e a altura mínima de toque. */
export const manualButtonSx = {
  '& .MuiButton-root': { minHeight: { xs: 40, sm: 32 }, color: C.violet, borderColor: C.violet, '&:hover': { borderColor: C.violet, bgcolor: 'rgba(68,51,180,.06)' } },
} as const

/** Aviso amarelo dentro do formulário (valor alto, consentimento): mesma cor do Alert de aviso do MUI. */
export const warnBoxSx = {
  display: 'flex', flexDirection: 'column', gap: 0.75, p: '10px 12px', borderRadius: '8px', bgcolor: CALLOUT.warnBg, color: CALLOUT.warnText, fontSize: 13.5, maxWidth: 520,
} as const
export const warnLineSx = { display: 'flex', gap: 0.75, alignItems: 'flex-start', fontSize: 13, color: CALLOUT.warnText } as const
